import { Box, Rating, Typography } from "@mui/material";
import { StarRounded, StarBorderRounded } from "@mui/icons-material";
import { Cartao } from "../../../../core/styles/superficies";

/**
 * A nota média é um número-herói, não um gráfico: é um valor só, e a leitura
 * que importa é "quanto" — as estrelas abaixo dão a referência da escala.
 */
export const NotaMediaDestaque = ({ nota, total }: { nota: number | null; total: number }) => (
    <Cartao sx={{ height: "100%", p: 2.5, display: "flex", flexDirection: "column", justifyContent: "center" }}>
        <Typography variant="caption" color="text.secondary" sx={{ textTransform: "uppercase", letterSpacing: .4 }}>
            Nota média
        </Typography>

        {nota === null ? (
            <Typography variant="h4" fontWeight={700} color="text.disabled" sx={{ mt: .5 }}>
                —
            </Typography>
        ) : (
            <>
                <Box sx={{ display: "flex", alignItems: "baseline", gap: .75, mt: .5 }}>
                    <Typography sx={{ fontSize: "2.75rem", lineHeight: 1, fontWeight: 700, fontVariantNumeric: "tabular-nums" }}>
                        {nota.toFixed(1).replace(".", ",")}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">de 5</Typography>
                </Box>
                <Rating
                    value={nota}
                    precision={0.1}
                    readOnly
                    size="small"
                    icon={<StarRounded fontSize="inherit" />}
                    emptyIcon={<StarBorderRounded fontSize="inherit" />}
                    sx={{ mt: 1 }}
                />
            </>
        )}

        <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
            {total === 0
                ? "Nenhuma avaliação no período"
                : `${total} ${total === 1 ? "avaliação respondida" : "avaliações respondidas"}`}
        </Typography>
    </Cartao>
);

/** Indicador simples de apoio — rótulo, número e uma linha de contexto. */
export const IndicadorSimples = ({ rotulo, valor, apoio }: { rotulo: string; valor: string | number; apoio?: string }) => (
    <Cartao sx={{ height: "100%", p: 2.5, display: "flex", flexDirection: "column", justifyContent: "center" }}>
        <Typography variant="caption" color="text.secondary" sx={{ textTransform: "uppercase", letterSpacing: .4 }}>
            {rotulo}
        </Typography>
        <Typography sx={{ fontSize: "1.75rem", lineHeight: 1.2, fontWeight: 700, mt: .5, fontVariantNumeric: "tabular-nums" }}>
            {valor}
        </Typography>
        {!!apoio && (
            <Typography variant="caption" color="text.secondary" sx={{ mt: .5 }}>
                {apoio}
            </Typography>
        )}
    </Cartao>
);
